<template>
	<div>
		<div class="p-16 box radius-8">
			<div class="color-gy-9 fz-14 fw-500">
				交付内容是否需要审核
				<el-switch
					:value="isAudit"
					inactive-color="#E2E3E8"
					:active-value="activeValue"
					:inactive-value="inactiveValue"
					@change="confirm"
				></el-switch>
			</div>
			<div class="mt-16 yx-color-text-regular font-h6-regular">
				<p class="mt-12">开启后，待交付的合作进度【确认开播】时提交的交付内容，需要审核通过后才会变为已交付</p>
			</div>
		</div>
		<el-dialog
			custom-class="dialog-content"
			:append-to-body="true"
			title="提示"
			:visible.sync="dialogVisible"
			width="400px"
			:before-close="handleClose"
		>
			关闭后，当前处于待审核状态合作进度，将自动变为审核通过，是否确认关闭？
			<span slot="footer">
				<el-button @click="handleClose">取消</el-button>
				<el-button type="primary" @click="submit" :loading="btnLoading">确认</el-button>
			</span>
		</el-dialog>
	</div>
</template>

<script>
import { deliveryAuditEnable, deliveryAuditDisable, deliveryAuditStatus } from '@/api/settings.js';
export default {
	components: {},
	data() {
		return {
			activeValue: 1,
			inactiveValue: 0,
			isAudit: 0, // 开关状态
			dialogVisible: false,
			btnLoading: false,
		};
	},
	created() {
		this.getAudit();
	},
	methods: {
		async getAudit() {
			try {
				let { switchStatus } = await deliveryAuditStatus();

				this.isAudit = +switchStatus;
			} catch (error) {
				console.log(error);
			}
		},
		confirm() {
			if (+this.isAudit === 1) {
				this.dialogVisible = true;
			} else {
				this.submit();
			}
		},

		submit() {
			if (+this.isAudit === 0) {
				this.handleEnable();
			} else {
				this.handleDisable();
			}
		},
		async handleEnable() {
			try {
				this.btnLoading = true;
				let res = await deliveryAuditEnable();
				this.$message.success('操作成功！');
				this.btnLoading = false;
				this.isAudit = 1;
			} catch (error) {
				console.log(error);
				this.btnLoading = false;
			}
		},
		async handleDisable() {
			try {
				this.btnLoading = true;
				let res = await deliveryAuditDisable();
				this.$message.success('操作成功！');
				this.dialogVisible = false;
				this.btnLoading = false;
				this.isAudit = 0;
			} catch (error) {
				console.log(error);
				this.btnLoading = false;
			}
		},
		handleClose() {
			this.dialogVisible = false;
		},
	},
};
</script>
<style lang="less" scoped>
.box {
	background: #f7f8fa;
}
.fw-500 {
	font-weight: 500 !important;
}
</style>
